module.exports = __webpack_public_path__ + "img/logo-white-horizontal.c90e7b0c.svg";